<template>
  <field-label :label="label" :subtitle="subtitle" :required="required">
    <template #label-extra v-if="clearable && !$attrs.disabled && !$attrs.readonly">
      <v-btn text color="primary" class="text-none" @click="emitInput(null)">Limpar</v-btn>
    </template>
    <v-radio-group
      class="mt-1 mb-4 pl-3"
      dense
      :value="value"
      v-on="$listeners"
      v-bind="$attrs"
      @change="emitInput"
      :row="row"
    >
      <v-radio
        class="mr-10"
        :label="option.text"
        v-for="option in options"
        :key="`option-${option.value}`"
        :value="option.value"
      />
      <span v-if="!!appendText" class="subtitle">{{ appendText }}</span>
    </v-radio-group>
  </field-label>
</template>

<script>
import FieldLabel from './FieldLabel.vue'
export default {
  components: { FieldLabel },
  props: {
    appendText: String,
    value: null,
    label: String,
    row: Boolean,
    subtitle: String,
    /**
     * Array de objectos no formato { text, value }, no qual
     * value é a chave e text é o nome à frente do radio
     */
    options: Array,

    /**
     * Indica se deve ser exibida opção para
     * zerar o radio
     */
    clearable: Boolean,
    required: Boolean,
  },
  methods: {
    emitInput(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style></style>
